import { render, staticRenderFns } from "./dropzone.vue?vue&type=template&id=afc09c9a&scoped=true&"
import script from "./dropzone.vue?vue&type=script&lang=js&"
export * from "./dropzone.vue?vue&type=script&lang=js&"
import style0 from "./dropzone.vue?vue&type=style&index=0&id=afc09c9a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc09c9a",
  null
  
)

export default component.exports